/**
 * DASHBOARD-RPS-QUESTIONS-SKELETON.WIDGET
 * Skeleton adapté à dashboard-rps-questions.widget.tsx : texte d'intro, puis 3 sections
 * (une par ordre de priorité) avec quelques lignes de question (libellé + barre de
 * répartition + badge), et un reflet qui balaie.
 */
import Skeleton, { SkeletonShine } from "@/components/skeleton"

const SECTION_COUNT = 3
const ROWS_PER_SECTION = 2

function SkeletonQuestionRow() {
  return (
    <div className="flex items-center" style={{ padding: "10px 0", gap: 20 }}>
      <Skeleton width={260} height={14} style={{ flexShrink: 0 }} />
      <div style={{ flex: 1 }}>
        <Skeleton width="100%" height={16} borderRadius={4} />
        <Skeleton width={140} height={11} style={{ marginTop: 8 }} />
      </div>
      <Skeleton width={150} height={24} borderRadius={12} style={{ flexShrink: 0 }} />
    </div>
  )
}

function SkeletonSection() {
  return (
    <div style={{ marginBottom: 36 }}>
      <Skeleton width={220} height={18} style={{ marginBottom: 28 }} />
      {Array.from({ length: ROWS_PER_SECTION }).map((_, i) => (
        <SkeletonQuestionRow key={i} />
      ))}
    </div>
  )
}

export default function DashboardRpsQuestionsSkeletonWidget() {
  return (
    <div className="rel" style={{ overflow: "hidden" }}>
      <Skeleton width={340} height={13} style={{ marginBottom: 10 }} />
      <Skeleton width={260} height={13} style={{ marginBottom: 28 }} />

      {Array.from({ length: SECTION_COUNT }).map((_, i) => (
        <SkeletonSection key={i} />
      ))}

      <SkeletonShine />
    </div>
  )
}
